(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["consentement-telechargement"] && !Shopify.designMode) return;
  try {
    // Version du texte de consentement. A changer si le texte change : l'attribut de
  // commande garde ainsi la trace de ce que l'acheteur a exactement accepte.
  var VERSION = 'v1.1 2026-09-11';

  // Nom de l'attribut de commande. Il doit rester identique au name du champ cache.
  var ATTRIBUT = 'Immediate download consent';

  // Message affiche sous la case quand on clique sur Check out sans avoir coche.
  var MESSAGE_ERREUR = 'Please tick the box above to continue.';

  function afficherErreur(bloc, texte) {
    var erreur = bloc.querySelector('[data-sr-erreur]');
    if (erreur) erreur.textContent = texte;
    if (texte) {
      bloc.classList.add('sr-consentement--erreur');
    } else {
      bloc.classList.remove('sr-consentement--erreur');
    }
  }

  // Affiche ou masque les boutons de paiement express. Masque, le bloc est aussi
  // rendu inerte : ni clic, ni tabulation, ni lecture d'ecran.
  function montrerExpress(visible) {
    var express = document.querySelector('[data-sr-express]');
    if (!express) return;
    if (visible) {
      express.classList.add('sr-express--visible');
      express.removeAttribute('inert');
      express.removeAttribute('aria-hidden');
    } else {
      express.classList.remove('sr-express--visible');
      express.setAttribute('inert', '');
      express.setAttribute('aria-hidden', 'true');
    }
  }

  // Ecrit l'attribut sur le panier lui-meme. C'est ce qui rend le paiement express
  // possible : ces boutons n'envoient pas le formulaire du panier, donc le champ
  // cache ne partirait pas avec la commande.
  function enregistrerSurLePanier(valeur) {
    var corps = { attributes: {} };
    corps.attributes[ATTRIBUT] = valeur;
    return fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart/update.js'
      : '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corps)
    }).then(function (reponse) {
      if (!reponse.ok) throw new Error('cart/update.js a repondu ' + reponse.status);
      return reponse.json();
    });
  }

  function synchroniser() {
    var bloc = document.querySelector('[data-sr-consentement]');
    if (!bloc) return;
    var laCase = bloc.querySelector('[data-sr-case]');
    var trace = bloc.querySelector('[data-sr-trace]');
    var coche = !!(laCase && laCase.checked);

    var valeur = coche
      ? 'accepted ' + new Date().toISOString() + ' (' + VERSION + ')'
      : '';

    // Le champ cache couvre le chemin normal : il part avec le formulaire du panier,
    // meme si la requete ci-dessous echoue.
    if (trace) trace.value = valeur;

    if (coche) {
      afficherErreur(bloc, '');
      // Les boutons express n'apparaissent qu'une fois l'attribut vraiment ecrit sur
      // le panier. En cas d'echec, ils restent masques et le bouton Check out suffit.
      enregistrerSurLePanier(valeur)
        .then(function () {
          if (laCase.checked) montrerExpress(true);
        })
        .catch(function (erreur) {
          montrerExpress(false);
          console.warn('Consentement : attribut non enregistre sur le panier.', erreur);
        });
    } else {
      montrerExpress(false);
      enregistrerSurLePanier('').catch(function () {});
    }
  }

  document.addEventListener('change', function (evenement) {
    var cible = evenement.target;
    if (cible && cible.hasAttribute && cible.hasAttribute('data-sr-case')) {
      synchroniser();
    }
  });

  // Clic sur Check out sans avoir coche : message sous la case et focus dessus.
  // Pas de preventDefault : l'attribut required bloque deja l'envoi du formulaire et
  // le navigateur affiche sa propre bulle. L'ecouteur est pose sur le document car
  // Dawn reconstruit le pied de panier, et le bouton avec lui.
  document.addEventListener('click', function (evenement) {
    var cible = evenement.target;
    if (!cible || !cible.closest) return;
    var bouton = cible.closest('#checkout');
    if (!bouton) return;

    var bloc = document.querySelector('[data-sr-consentement]');
    if (!bloc) return;
    var laCase = bloc.querySelector('[data-sr-case]');
    if (!laCase) return;

    if (laCase.checked) {
      afficherErreur(bloc, '');
      return;
    }

    afficherErreur(bloc, MESSAGE_ERREUR);
    laCase.focus();
  });

  // A l'arrivee sur la page, la case n'est jamais cochee : une case pre-cochee ne vaut
  // pas consentement. Si le panier garde l'attribut d'une visite precedente, on l'efface
  // pour qu'aucun consentement ancien ne parte avec une commande d'aujourd'hui.
  function demarrer() {
    var bloc = document.querySelector('[data-sr-consentement]');
    if (!bloc) return;
    montrerExpress(false);
    var laCase = bloc.querySelector('[data-sr-case]');
    if (laCase) laCase.checked = false;
    var trace = bloc.querySelector('[data-sr-trace]');
    if (trace) trace.value = '';
    if (bloc.dataset.srEnregistre) {
      enregistrerSurLePanier('').catch(function () {});
      bloc.dataset.srEnregistre = '';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }

  // Dawn reconstruit le pied de panier apres une modification de quantite.
  document.addEventListener('shopify:section:load', demarrer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lecteur-audio"] && !Shopify.designMode) return;
  try {
    /* Bouton « Show all » de la grille d'extraits : ouvre la liste repliee sur
     mobile. Ecoute posee sur document, sans Liquid : elle survit a la
     reconstruction d'une section dans l'editeur de theme. Le script
     sr-audio.js, lui, s'occupe du son et de l'enchainement. */
  document.addEventListener('click', function (evenement) {
    var cible = evenement.target;
    if (!cible || typeof cible.closest !== 'function') return;
    var bouton = cible.closest('[data-sr-tout]');
    if (!bouton) return;

    var conteneur = bouton.closest('[data-sr-extraits]');
    var liste = conteneur ? conteneur.querySelector('.sr-extraits--repliable') : null;
    if (liste) liste.classList.add('sr-extraits--ouvert');

    bouton.setAttribute('aria-expanded', 'true');
    bouton.hidden = true;

    // Le bouton disparait sous le clavier : le focus passe au 7e extrait.
    if (!liste) return;
    var extraits = liste.querySelectorAll('[data-sr-extrait]');
    var septieme = extraits.length > 6 ? extraits[6] : null;
    var lecture = septieme ? septieme.querySelector('[data-sr-bouton]') : null;
    if (lecture && typeof lecture.focus === 'function') lecture.focus();
  });
  } catch(e) { console.error(e); }
})();

})();
